import React, { Component, PropTypes } from 'react';

export default class JurySticky extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
		children: PropTypes.any,
		className: PropTypes.string,
	};

	static defaultProps = {
		className: '',
	};

	constructor(props) {
		super(props);

		this.mounted = true;
		this.scrollHandler = this.scrollHandler.bind(this);

		this.state = {
			isSticky: false,
			stickAtPos: 0,
			stickyHeight: 0,
			headerHeight: 0,
		};
	}

	componentWillMount() {
		if (this.props.browser) {
			this.props.browser.scroll.register(this.scrollHandler);
		}
	}

	componentDidMount() {
		this.updateDimensions();
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.browser.window.width !== nextProps.browser.window.width) {
			this.updateDimensions();
		}
	}

	componentWillUnmount() {
		this.mounted = false;

		if (this.props.browser) {
			this.props.browser.scroll.deregister(this.scrollHandler);
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.browser.window.width !== this.props.browser.window.width ||
			nextProps.update !== this.props.update ||
			nextState !== this.state
		);
	}

	render() {
		let stickyClass = this.props.className;
		let className = ' stickifier span14';

		const stickyStyle = {};
		const placeholderStyle = {};

		if (this.state.isSticky) {
			placeholderStyle.height = this.state.stickyHeight;

			stickyStyle.position = 'fixed';
			stickyStyle.top = this.state.headerHeight;
			stickyStyle.height = this.state.stickyHeight;
			stickyStyle.zIndex = 100;
		}

		return (
			<div className={className}>
				<div style={placeholderStyle}></div>
				<div style={stickyStyle} className={stickyClass} ref='stickyElement'>
					{this.props.children}
				</div>
			</div>
		);
	}

	updateDimensions() {
		const headerHeight = document.querySelector('.header-main').offsetHeight;
		const mainOffsetTop = this.refs.stickyElement ? this.refs.stickyElement.offsetTop : 0;
		const distanceToMenu = (mainOffsetTop - headerHeight) ? (mainOffsetTop - headerHeight) : 9999;

		const stickyHeight = (this.refs.stickyElement) ? this.refs.stickyElement.offsetHeight : 0;

		if (distanceToMenu === 9999) {
			setTimeout(() => {
				this.updateDimensions();
			}, 200);
		}

		this.mounted && this.setState({
			...this.state,
			stickAtPos: distanceToMenu,
			stickyHeight: stickyHeight,
			headerHeight: headerHeight,
		});
	}

	scrollHandler(e) {
		if (e.scrollY === this.prevSrollY) {
			return false; // noop
		} else {
			this.prevSrollY = e.scrollY;
		}

		const isMobile = (this.props.browser.window.width <= 719);
		const isSticky = (e.scrollY >= this.state.stickAtPos && !isMobile);

		if (this.state.stickyHeight <= 0 || this.state.stickAtPos <= 0) {
			return this.updateDimensions();
		}

		// stop setting state if not necessary
		if (this.state.isSticky === isSticky) {
			return false;  // noop
		}

		this.setState({
			...this.state,
			isSticky,
		});
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jury/jurySticky.js
 **/